import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"align-items":"center","display":"flex"} }
const _hoisted_2 = { style: {"align-items":"center","display":"flex"} }

import { PropType, ref, watch, h, computed } from "vue";
import { cloneDeep } from "lodash";
import { ordinaryNodeModel } from "../../typescript/nodeModel";
import {
  AuditTypeEnum,
  ExpireActionEnum,
  ExpireTypeEnum,
  FlowNodeStateEnum,
  NodeTypeEnum,
} from "../../typescript/nodeEnum";
import { Form, message } from "ant-design-vue";
import { userData, roleData, departmentData, postData } from "../../typescript/mockData";
import {
  CheckOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons-vue";
// 组件属性定义

export default /*@__PURE__*/_defineComponent({
  __name: 'ordinaryNode',
  props: {
  isVisibles: Boolean,
  dialogTitle: String,
  nodeModel: { type: Object as PropType<any>, required: true },
},
  emits: ["closeBnt", "saveNodeClick"],
  setup(__props, { emit: __emit }) {

const props = __props;

// 声明 emit
const emit = __emit;

//流程节点模型
const flowNodeData = ref<ordinaryNodeModel>({
  nodeId: "",
  nodeType: NodeTypeEnum.OrdinaryNode,
  auditType: AuditTypeEnum.appointUser,
  isSetExamineExpire: false,
  expireDate: 1,
  expireAction: ExpireActionEnum.NoAction,
  isExpireRemind: false,
  soonExpireDate: 10,
  remindContent: "",
  expireType: ExpireTypeEnum.day,
  carbonCopyUser: [],
  nodeName: "",
  auditState: FlowNodeStateEnum.UnPublish,
  auditKey: [],
});

watch(
  () => props.isVisibles,
  () => {
    resetFields();
    if (props.isVisibles) {
      const nodeData = props.nodeModel;
      flowNodeData.value.nodeId = nodeData.nodeId;
      flowNodeData.value.nodeName = nodeData.nodeName;
      flowNodeData.value.auditType =
        nodeData.auditType === 0 ? AuditTypeEnum.appointUser : nodeData.auditType;
      flowNodeData.value.auditState =
        nodeData.auditState === 0 ? FlowNodeStateEnum.UnPublish : nodeData.auditState;
      flowNodeData.value.auditKey = nodeData.auditKey ?? [];
      flowNodeData.value.carbonCopyUser = nodeData.carbonCopyUser ?? [];
      flowNodeData.value.isSetExamineExpire = nodeData.isSetExamineExpire ?? false;
      flowNodeData.value.expireDate = nodeData.expireDate ?? 1;
      flowNodeData.value.expireAction =
        nodeData.expireAction ?? ExpireActionEnum.NoAction;
      flowNodeData.value.isExpireRemind = nodeData.isExpireRemind ?? false;
      flowNodeData.value.soonExpireDate = nodeData.soonExpireDate ?? 10;
      flowNodeData.value.remindContent = nodeData.remindContent ?? "";
      flowNodeData.value.nodeType = nodeData.nodeType ?? NodeTypeEnum.OrdinaryNode;
      flowNodeData.value.expireType =
        nodeData.expireType === 0 || nodeData.expireType === undefined
          ? 1
          : nodeData.expireType;
    }
  }
);

// 动态验证规则
const dynamicRules = computed(() => {
  const rules: any = {
    label: [{ required: true, message: "请输入节点名称" }],
    auditType: [{ required: true, message: "请选择审核方式" }],
  };

  // 根据当前审核方式动态设置验证规则
  switch (flowNodeData.value.auditType) {
    case AuditTypeEnum.appointUser:
      rules.auditKey = [{ required: true, message: "请选择审核人员" }];
      break;
    case AuditTypeEnum.appointRole:
      rules.auditKey = [{ required: true, message: "请选择审核角色" }];
      break;
    case AuditTypeEnum.appointDepartment:
      rules.auditKey = [{ required: true, message: "请选择审核部门" }];
      break;
    case AuditTypeEnum.appointPost:
      rules.auditKey = [{ required: true, message: "请选择审核岗位" }];
      break;
  }

  // 审核期限相关验证
  if (flowNodeData.value.isSetExamineExpire) {
    rules.expireDate = [{ required: true, message: "请输入超时日期" }];
    rules.expireAction = [{ required: true, message: "请选择超时动作" }];

    if (flowNodeData.value.isExpireRemind) {
      rules.soonExpireDate = [{ required: true, message: "请输入提前提醒时间" }];
      rules.remindContent = [{ required: true, message: "请输入提示信息" }];
    } else {
      rules.soonExpireDate = [];
      rules.remindContent = [];
    }
  } else {
    // 不设置审核期限时，清空相关验证
    rules.expireDate = [];
    rules.expireAction = [];
    rules.isExpireRemind = [];
    rules.soonExpireDate = [];
    rules.remindContent = [];
  }

  return rules;
});

const { resetFields, validate, validateInfos } = Form.useForm(
  flowNodeData.value,
  dynamicRules
);

//审核方式改变
const auditTypeChange = function () {
  flowNodeData.value.auditKey = [];
};

const submitForm = () => {
  validate()
    .then(() => {
      if (
        flowNodeData.value.carbonCopyUser !== undefined &&
        flowNodeData.value.carbonCopyUser.some((f) =>
          flowNodeData.value.auditKey.includes(f)&&
            flowNodeData.value.auditType === AuditTypeEnum.appointUser
        )
      ) {
        message.warning("审核人和抄送人不能是同一个人");
        return;
      }
      if (
        flowNodeData.value.isExpireRemind &&
        (flowNodeData.value.remindContent == "" ||
          flowNodeData.value.remindContent === undefined)
      ) {
        message.warning("请输入过期提醒内容");
        return;
      }
      emit("saveNodeClick", cloneDeep(flowNodeData.value));
      emit("closeBnt");
    })
    .catch(() => {
      // message.error(ers);
    });
};

//关闭事件
const handleClose = () => {
  emit("closeBnt");
  // resetForm(ruleFormRef.value);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    width: 600,
    title: __props.dialogTitle,
    placement: "right",
    open: __props.isVisibles,
    onClose: handleClose
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, {
        style: {"margin-right":"8px"},
        icon: h(_unref(CloseOutlined)),
        onClick: handleClose
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
          _createTextVNode("取消", -1)
        ]))]),
        _: 1
      }, 8, ["icon"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: submitForm,
        icon: h(_unref(CheckOutlined))
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
          _createTextVNode("保存节点", -1)
        ]))]),
        _: 1
      }, 8, ["icon"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        rules: dynamicRules.value,
        "label-col": { span: 4 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_divider, null, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("设置节点信息", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_a_form_item, _mergeProps({ label: "节点id" }, _unref(validateInfos).nodeId, { name: "nodeId" }), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: flowNodeData.value.nodeId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((flowNodeData.value.nodeId) = $event)),
                placeholder: "请输入节点id",
                maxlength: "20",
                disabled: "true",
                "show-count": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_form_item, _mergeProps({ label: "节点名称" }, _unref(validateInfos).label, { name: "label" }), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: flowNodeData.value.nodeName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((flowNodeData.value.nodeName) = $event)),
                placeholder: "请输入节点名称",
                maxlength: "10",
                "show-count": "",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_divider, null, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("设置审核信息", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_a_form_item, _mergeProps({ label: "审核方式" }, _unref(validateInfos).auditType, { name: "auditType" }), {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: flowNodeData.value.auditType,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((flowNodeData.value.auditType) = $event)),
                name: "radioGroup",
                onChange: auditTypeChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, {
                    value: _unref(AuditTypeEnum).appointUser
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode("指定人员", -1)
                    ]))]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_a_radio, {
                    value: _unref(AuditTypeEnum).appointRole
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode("指定角色", -1)
                    ]))]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_a_radio, {
                    value: _unref(AuditTypeEnum).appointDepartment
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode("指定部门", -1)
                    ]))]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_a_radio, {
                    value: _unref(AuditTypeEnum).appointPost
                  }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createTextVNode("指定岗位", -1)
                    ]))]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 16),
          (flowNodeData.value.auditType === _unref(AuditTypeEnum).appointUser)
            ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                key: 0,
                label: "审核人员"
              }, _unref(validateInfos).auditKey, { name: "auditKey" }), {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    allowClear: "",
                    value: flowNodeData.value.auditKey,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((flowNodeData.value.auditKey) = $event)),
                    options: 
            _unref(userData).map((s) => {
              return { value: s.userId, label: s.userName };
            })
          
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true),
          (flowNodeData.value.auditType === _unref(AuditTypeEnum).appointRole)
            ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                key: 1,
                label: "审核角色"
              }, _unref(validateInfos).auditKey, { name: "auditKey" }), {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    allowClear: "",
                    value: flowNodeData.value.auditKey,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((flowNodeData.value.auditKey) = $event)),
                    options: 
            _unref(roleData).map((s) => {
              return { value: s.roleId, label: s.roleName };
            })
          
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true),
          (flowNodeData.value.auditType === _unref(AuditTypeEnum).appointDepartment)
            ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                key: 2,
                label: "审核部门"
              }, _unref(validateInfos).auditKey, { name: "auditKey" }), {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    allowClear: "",
                    value: flowNodeData.value.auditKey,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((flowNodeData.value.auditKey) = $event)),
                    options: 
            _unref(departmentData).map((s) => {
              return { value: s.departmentId, label: s.departmentName };
            })
          
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true),
          (flowNodeData.value.auditType === _unref(AuditTypeEnum).appointPost)
            ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                key: 3,
                label: "审核岗位"
              }, _unref(validateInfos).auditKey, { name: "auditKey" }), {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    allowClear: "",
                    value: flowNodeData.value.auditKey,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((flowNodeData.value.auditKey) = $event)),
                    options: 
            _unref(postData).map((s) => {
              return { value: s.postId, label: s.postName };
            })
          
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, { label: "抄送给" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                allowClear: "",
                mode: "multiple",
                style: {"width":"80%"},
                value: flowNodeData.value.carbonCopyUser,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((flowNodeData.value.carbonCopyUser) = $event)),
                options: 
            _unref(userData).map((s) => {
              return { value: s.userId, label: s.userName };
            })
          
              }, null, 8, ["value", "options"]),
              _createVNode(_component_a_tooltip, {
                placement: "bottom",
                color: "#f50"
              }, {
                title: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("span", null, "当前节点审核通过后，流程会自动发送给抄送人", -1)
                ]))]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleOutlined), { style: {"font-size":"20px","margin-left":"5px","color":"#f50"} })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_divider, null, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("设置审核期限", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "审核期限" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: flowNodeData.value.isSetExamineExpire,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((flowNodeData.value.isSetExamineExpire) = $event)),
                name: "radioGroup1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: true }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode("设置审核期限", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: false }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode("任意时间审核", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          (flowNodeData.value.isSetExamineExpire)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 4,
                label: "超时日期"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _cache[29] || (_cache[29] = _createTextVNode(" 从 ", -1)),
                    _createVNode(_component_a_input_number, {
                      value: flowNodeData.value.expireDate,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((flowNodeData.value.expireDate) = $event)),
                      min: 1,
                      max: 100,
                      style: {"width":"120px"}
                    }, null, 8, ["value"]),
                    _createVNode(_component_a_select, {
                      value: flowNodeData.value.expireType,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((flowNodeData.value.expireType) = $event)),
                      style: {"width":"120px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                            _createTextVNode("天", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createTextVNode("小时", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _cache[30] || (_cache[30] = _createTextVNode(" 后，未审批自动执行超时动作 ", -1))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (flowNodeData.value.isSetExamineExpire)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 5,
                label: "超时动作"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: flowNodeData.value.expireAction,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((flowNodeData.value.expireAction) = $event)),
                    name: "radioGroup2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        value: _unref(ExpireActionEnum).NoAction
                      }, {
                        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                          _createTextVNode("等待审批", -1)
                        ]))]),
                        _: 1
                      }, 8, ["value"]),
                      _createVNode(_component_a_radio, {
                        value: _unref(ExpireActionEnum).Approve
                      }, {
                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                          _createTextVNode("自动批准", -1)
                        ]))]),
                        _: 1
                      }, 8, ["value"]),
                      _createVNode(_component_a_radio, {
                        value: _unref(ExpireActionEnum).AuditRefuse
                      }, {
                        default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                          _createTextVNode("自动拒绝", -1)
                        ]))]),
                        _: 1
                      }, 8, ["value"]),
                      _createVNode(_component_a_radio, {
                        value: _unref(ExpireActionEnum).RejectNode
                      }, {
                        default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                          _createTextVNode("驳回到上个节点", -1)
                        ]))]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (flowNodeData.value.isSetExamineExpire)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 6,
                label: "过期提醒"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    value: flowNodeData.value.isExpireRemind,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((flowNodeData.value.isExpireRemind) = $event)),
                    name: "radioGroup3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, { value: true }, {
                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                          _createTextVNode("提醒", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: false }, {
                        default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                          _createTextVNode("不提醒", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (flowNodeData.value.isExpireRemind && flowNodeData.value.isSetExamineExpire)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 7,
                label: "提前"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_a_input_number, {
                      value: flowNodeData.value.soonExpireDate,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((flowNodeData.value.soonExpireDate) = $event)),
                      min: 10,
                      max: 60,
                      style: {"width":"50%"}
                    }, null, 8, ["value"]),
                    _cache[37] || (_cache[37] = _createElementVNode("span", null, "分钟提醒审核人", -1))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (flowNodeData.value.isExpireRemind && flowNodeData.value.isSetExamineExpire)
            ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                key: 8,
                label: "提示信息"
              }, _unref(validateInfos).remindContent, { name: "remindContent" }), {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: flowNodeData.value.remindContent,
                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((flowNodeData.value.remindContent) = $event)),
                    placeholder: "请输入提示信息，即将超时会把该内容发送给审核人",
                    maxlength: "20",
                    "show-count": "",
                    allowClear: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["rules"])
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})